import React from 'react';

const SpaceRow = ({ space, active, disabled, onClick }) => {
  const isAvailable = Number(space?.quantity) > 0;
  const price =
    space?.price != null && !Number.isNaN(Number(space.price))
      ? Number(space.price).toFixed(2)
      : '0.00';

  const isDisabled = disabled || !onClick;

  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      className={[
        'w-full text-left rounded-2xl p-5 border transition duration-200 bg-white',
        active
          ? 'border-yellow-400 bg-yellow-50 ring-1 ring-yellow-300 shadow-md'
          : isDisabled
            ? 'border-gray-200 cursor-default'
            : 'border-gray-200 hover:border-yellow-300',
        isDisabled ? 'opacity-100' : '',
      ].join(' ')}
      aria-disabled={isDisabled}
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:items-start">
        {/* Left: name + meta */}
        <div className="md:col-span-3 order-1">
          <h3 className="text-lg font-bold text-gray-900">{space?.name}</h3>
          {space?.size && (
            <p className="text-sm text-gray-500">
              {space.size} m<sup>2</sup>
            </p>
          )}
          <p
            className={`text-sm font-medium mt-1 ${
              isAvailable ? 'text-green-600' : 'text-red-500'
            }`}
          >
            {isAvailable ? `${space.quantity} available` : 'Sold out'}
          </p>
        </div>

        {/* Middle: description (expanded, smaller font) */}
        <div className="md:col-span-6 order-3 md:order-2 md:px-2">
          {space.description ? (
            <div className="text-xs md:text-sm text-gray-600 leading-relaxed whitespace-pre-line break-words">
              {space.description}
            </div>
          ) : (
            <p className="text-xs text-gray-400 italic">No description.</p>
          )}
        </div>

        {/* Right: price */}
        <div className="md:col-span-3 order-2 md:order-3 md:text-right">
          <span className="text-2xl font-bold text-yellow-500 whitespace-nowrap">
            {price}€
          </span>
          <span className="text-xs text-gray-400 font-medium block">
            + Taxes
          </span>
        </div>
      </div>
    </button>
  );
};

export default SpaceRow;
